"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

const HomeLink = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname();

  return (
    <Link
      href="/"
      rel="author"
      transitionTypes={pathname === "/" ? undefined : ["nav-lateral"]}
      aria-label="Home"
      className="flex shrink-0 items-center hover:no-underline"
    >
      {children}
    </Link>
  );
};

export { HomeLink };
